import { getYearByMonth } from "./getYearByMonth"
import { t } from "i18next";

export const getSubscriptionTitle = (period: number): string => (getYearByMonth(period) >= 1) ? t(
    "subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE",
    { count: getYearByMonth(period) }
) : t("subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE_MONTHLY");
